import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: { search: string } = {
	search: "",
};

const initializationSlice = createSlice({
	name: "game",
	initialState,
	reducers: {
		setSearch: (state, action: PayloadAction<string>) => {
			state.search = action.payload;
		},
	},
});

export const { setSearch } = initializationSlice.actions;
export default initializationSlice.reducer;
